import { Button, Container, Label } from '@playcanvas/pcui';

import { Events } from '../events';
import { ColorPanel } from './color-panel';
import { localize } from './localization';
import { ViewPanel } from './view-panel';

// Docks View Options and Colors as the two tabs of one panel. They were separate floating
// panels that were already mutually exclusive - each hides itself when the other reports
// visible - so the tabs only drive the panels' existing setVisible events and reflect their
// visible events. The panels keep owning their own state.
class PropertiesPanel extends Container {
    constructor(events: Events, viewPanel: ViewPanel, colorPanel: ColorPanel, args = {}) {
        args = {
            ...args,
            id: 'properties-panel',
            class: 'panel'
        };

        super(args);

        const header = new Container({
            class: 'panel-header'
        });

        header.append(new Label({
            class: 'panel-header-icon',
            text: ''
        }));

        header.append(new Label({
            class: 'panel-header-label',
            text: localize('panel.properties')
        }));

        const tabs = new Container({
            class: 'properties-tabs'
        });
        tabs.dom.setAttribute('role', 'tablist');

        const createTab = (text: string, visibleEvent: string, setVisibleEvent: string) => {
            const tab = new Button({
                class: 'properties-tab',
                text
            });
            tab.dom.setAttribute('role', 'tab');
            tab.dom.setAttribute('aria-selected', 'false');

            tab.on('click', () => {
                events.fire(setVisibleEvent, true);
            });

            events.on(visibleEvent, (visible: boolean) => {
                tab.class[visible ? 'add' : 'remove']('active');
                tab.dom.setAttribute('aria-selected', String(visible));
            });

            tabs.append(tab);
        };

        createTab(localize('panel.view-options'), 'viewPanel.visible', 'viewPanel.setVisible');
        createTab(localize('panel.colors'), 'colorPanel.visible', 'colorPanel.setVisible');

        this.append(header);
        this.append(tabs);
        this.append(viewPanel);
        this.append(colorPanel);

        // a docked panel always shows one of its tabs
        events.fire('viewPanel.setVisible', true);
    }
}

export { PropertiesPanel };
